"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scan = void 0;
class Scan {
    constructor(obj) {
        // Take in an object, and assign every property from that
        // object onto this newly created Scan object.
        for (const prop in obj) {
            this[prop] = obj[prop];
        }
    }
}
exports.Scan = Scan;
//# sourceMappingURL=Scan.js.map